export default "__VITE_ASSET__4c2dae73__"